<template>
  <div class="partners-advantages">
    <div class="partners-advantages__content">
      <h2 class="partners-advantages__title">
        Преимущества партнерства
      </h2>
      <p class="partners-advantages__text">
        Наша команда — это профессионалы, отвечающие за развитие фонда и качественное выполнение задач. Сотрудники имеют разные зоны ответственности.
      </p>
      <ul class="partners-advantages-list">
        <li class="partners-advantages-list__item">
          <span>
            <b>Защищенные платежи, каждый раз</b>
            Всегда знайте, что вы будете платить заранее. Ваш платеж  не будет разблокирован, пока вы не одобрите работу.
          </span>
        </li>
        <li class="partners-advantages-list__item">
          <span>
            <b>Круглосуточная поддержка</b>
            Вопросы? Наша круглосуточная служба поддержки  готова помочь в любое время и в любом месте.
          </span>
        </li>
      </ul>
      <ABtn
        label="Стать партнером"
        class="secondary"
      />
    </div>
    <picture class="partners-advantages__image">
      <source srcset="/local/templates/main/img/partners/advantages-desktop.png" media="(min-width: 1024px)">
      <img src="/local/templates/main/img/partners/advantages-mobile.png" alt="MDN">
    </picture>
  </div>
</template>

<script>
import { ABtn } from "../../ui";

export default {
  name: 'PartnersAdvantages',
  props: ['result'],
  components: {
    ABtn,
  }
}
</script>

<style lang="scss" scoped>
.partners-advantages {
  display: grid;
  grid-template-columns: 1fr 682px;
  grid-column-gap: 100px;
  margin-bottom: 118px;
  @include tablet{
    grid-template-columns: 1fr 371px;
    margin-bottom: 143px;
    grid-column-gap: 18px;
  }
  @include mobile{
    grid-template-columns: 1fr;
    margin-bottom: 51px;
    grid-row-gap: 25px;
  }
  &__image{
    border-radius: 6px;
    @include mobile{
     order: 1;
    }
  }
  &__content{
    @include mobile{
      order: 2;
    }
  }
  &__title{
    margin: 0 0 26px;
    @include tablet{
      margin: 0 0 19px;
    }
    @include mobile{
      margin: 0 0 54px;
      font-size: 18px;
      line-height: 28px;
    }
  }
  &__text{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 20px;
    @include tablet{
      margin-bottom: 17px;
    }
  }
  :deep{
    .a-btn{
      min-width: 284px;
      @include mobile{
        min-width: unset;
        width: 100%;
      }
    }
  }
}
.partners-advantages-list{
  list-style: none;
  margin-bottom: 19px;
  @include tablet{
    margin-bottom: 14px;
  }
  @include mobile{
    margin-bottom: 33px;
  }
  &__item{
    display: grid;
    grid-template-columns: 24px 1fr;
    grid-column-gap: 16px;
    margin-bottom: 17px;
    font-family: 'Montserrat';
    font-size: 18px;
    line-height: 28px;
    @include tablet{
      grid-column-gap: 13px;
      font-size: 14px;
      line-height: 20px;
    }
    &:before{
      content: '';
      display: block;
      width: 24px;
      height: 24px;
      background-color: #6367A7;
      border-radius: 50%;
      background-image: url("/local/templates/main/img/partners/advantages-list.png");
      background-repeat: no-repeat;
      background-size: 13px 10px;
      background-position: center;
    }
    b{
      display: block;
      font-weight: 600;
    }
  }
}
</style>